"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECTION_LABEL_WIDTH = exports.SECTION_LABEL_HEIGHT = exports.QUERY_LIST_SECTION_SKELETON = exports.QUERY_LIST_SECTION_ITEM_SKELETON = void 0;
const QUERY_LIST_SECTION_SKELETON = exports.QUERY_LIST_SECTION_SKELETON = 'query-list-section-skeleton';
const QUERY_LIST_SECTION_ITEM_SKELETON = exports.QUERY_LIST_SECTION_ITEM_SKELETON = 'query-list-section-item-skeleton';
const SECTION_LABEL_HEIGHT = exports.SECTION_LABEL_HEIGHT = 18;
const SECTION_LABEL_WIDTH = exports.SECTION_LABEL_WIDTH = 70;
//# sourceMappingURL=constants.js.map